import React, { HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { IconButton, Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import TableCell from '../../../../../../components/TableCell';
import { MdDelete as DeleteIcon } from '@react-icons/all-files/md/MdDelete';

interface SubOffice {
  id: number;
  dateCreate: string;
  installationSite: { socialReason: string };
  deleted?: boolean;
  creator: { user: { username: string; id: string } };
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  subOffices: SubOffice[];
  loading: boolean;
  openModal: Function;
}

const SubOfficesSection: React.FC<Props> = ({ subOffices, openModal, loading, ...props }) => {
  return (
    <div {...props}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Raison sociale</TableCell>
            <TableCell>Date création</TableCell>
            <TableCell>Date création</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {subOffices
            .sort((a, b) => {
              const aDate = new Date(a.dateCreate);
              const bDate = new Date(b.dateCreate);
              return bDate.valueOf() - aDate.valueOf();
            })
            .map(
              (subOffice) =>
                !subOffice.deleted && (
                  <TableRow key={subOffice.id}>
                    <TableCell>
                      <Link to={`/dashboard/customer/${subOffice.id}`}>
                        <span>{subOffice.installationSite.socialReason}</span>
                      </Link>
                    </TableCell>
                    <TableCell>{moment(subOffice.dateCreate).format('DD-MM-YY')}</TableCell>
                    <TableCell>
                      {subOffice.creator ? (
                        <Link to={`/dashboard/user/${subOffice.creator.user.id}`}>
                          <span>{subOffice.creator.user.username}</span>
                        </Link>
                      ) : (
                        'Non-renseigné'
                      )}
                    </TableCell>
                    <TableCell>
                      <IconButton size='small' onClick={() => openModal('delete-subOffice', subOffice)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                )
            )}
        </TableBody>
      </Table>

      {subOffices.length === 0 && <span>Aucun sous-compte rattaché à ce client.</span>}
    </div>
  );
};

export default SubOfficesSection;
